import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { CommanModalComponent } from '../comman-modal/comman-modal.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeliveryService } from 'src/app/services/delivery.service';
import { SignaturePad } from 'angular2-signaturepad';
import { CommanUsesService } from 'src/app/services/comman-uses.service';

@Component({
  selector: 'app-start-end-time-edit',
  templateUrl: './start-end-time-edit.component.html',
  styleUrls: ['./start-end-time-edit.component.scss']
})
export class StartEndTimeEditComponent implements OnInit {

  delivery: any;
  startEndTimeForm: any;
  btnDisabled: boolean = false;
  disabledBtn: boolean = false;
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  signaturePadOptions = {
    minWidth: 2,
    canvasWidth: 590,
    canvasHeight: 200
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CommanModalComponent>,
    private _snackBar: MatSnackBar,
    private deliveryService: DeliveryService,
    private commanUsesService: CommanUsesService,
  ) { 
    this.delivery = data.delivery;
    this.manageStartEndTimeForm();
  }

  async ngOnInit() {
    try {
      this.patch();
    } catch (error) {
      console.log("ERROR", error)
    }
  }

  manageStartEndTimeForm(){
    this.startEndTimeForm = new FormGroup({
      'startTime': new FormControl(''),
      'endTime': new FormControl(''),
    });
  }

  patch(){
    this.startEndTimeForm.patchValue({
      startTime: this.delivery.startTime,
      endTime: this.delivery.endTime,
    });
  }

  async onSubmit(){
    try {
      let promiseResult = await this.deliveryService.updateStartTimings(this.delivery.id, this.startEndTimeForm.value);
      if(promiseResult){
        this.dialogRef.close({
          success: true
        });
      }
    } catch (error) {
      console.log("ERROR", error);
      this.showSnackBar('Something went wrong');
    }
  }

  async showSnackBar(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  ngAfterViewInit() {
    /*
    setTimeout(() => {
      if (this.signaturePad) {
        this.signaturePad.clear();
      } else {
        console.error('SignaturePad is STILL undefined');
      }
    }, 0);
    */
  }

  drawComplete() {}

  clear() {
    this.signaturePad.clear();
  }

  async save() {
    try {
      if (this.signaturePad.isEmpty()) {
        this.commanUsesService.showSnackBar('Si prega di firmare prima di salvare.');
        return;
      }

      const base64 = this.signaturePad.toDataURL();
      this.disabledBtn = true;
      const result = await this.deliveryService.uploadSign(this.delivery.id, base64);
      this.delivery = result.delivery;
      this.commanUsesService.showSnackBar(result.message);
    } catch (error: any) {
      const errorMsg: string = error?.error?.message || 'SOMETHING_WENT_WRONG';
      this.commanUsesService.showSnackBar(errorMsg);
    } finally {
      this.disabledBtn = false;
    }
  }

  async deleteSignature() {
    try {
      this.disabledBtn = true;
      const result = await this.deliveryService.removeSign(this.delivery.id);
      this.delivery = result.delivery;
      this.commanUsesService.showSnackBar(result.message);
    } catch (error) {
      const errorMsg: string = error?.error?.message || 'SOMETHING_WENT_WRONG';
      this.commanUsesService.showSnackBar(errorMsg);
    } finally {
      this.disabledBtn = false;
    }
  }
}
